import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ApiCalls } from '../../api/api';
import { ALL_PERIODS } from '../../constants/queryKeys';
import { Period } from '../../api/generated/data-contracts';
import { fromMinutes } from '../../_helpers/milliseconds';

export const useAllPeriods = (
    options?: Omit<UseQueryOptions<Period[], unknown, Period[], string[]>, 'initialData'> & {
        initialData?: () => undefined;
    },
) =>
    useQuery({
        queryKey: [ALL_PERIODS],
        queryFn: () => ApiCalls.getAllPeriods().then(res => res.data),
        ...options,
        staleTime: fromMinutes(5),
    });
